import React from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Checkbox } from 'antd'

interface Props {
  onClick: () => void
  showArchived: boolean
  onShowArchivedChange: (checked: boolean) => void
  description?: React.ReactNode
}

export const HeaderList = ({ onClick, showArchived, onShowArchivedChange, description }: Props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: description ? 'space-between' : 'flex-end', gap: 24, marginBottom: 32 }}>
      {description}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
        <Checkbox
          checked={showArchived}
          onChange={(e) => onShowArchivedChange(e.target.checked)}
        >
          Показать архивные
        </Checkbox>
        <Button type='primary' size='large' icon={<PlusOutlined />} onClick={onClick}>
          Добавить баннер
        </Button>
      </div>
    </div>
  )
}
